import { authService } from './auth/auth-service';

export const getToken = async (forceRefresh: boolean = false) => {
  return authService.getToken(forceRefresh);
};
